module.exports = __webpack_public_path__ + "static/media/data3.1f8efde7.jpg";